export { D as DecryptionCriteriaType, E as Erc20ComparisonOperator, N as NftContractType, P as Profile, R as ReactionType, a as ReportReason } from '../../dist/ReportClaim-70c559d6.esm.js';
export { M as MetaTransaction, N as NativeTransaction, P as ProxyActionStatus, c as ProxyTransaction, S as SignedProtocolCall, a as TransactionError, b as TransactionErrorReason, d as TransactionEvent, T as TransactionKind, U as UnsignedTransaction } from '../../dist/Transactions-f93c1e86.esm.js';
import { _ as _inherits, a as _createSuper, b as _classCallCheck, d as _defineProperty, e as _assertThisInitialized, c as _createClass } from '../../dist/createClass-3115abc1.esm.js';
import { _ as _wrapNativeSuper } from '../../dist/wrapNativeSuper-76ffa30e.esm.js';

var InsufficientGasError = /*#__PURE__*/function (_Error) {
  _inherits(InsufficientGasError, _Error);
  var _super = _createSuper(InsufficientGasError);
  function InsufficientGasError(asset) {
    var _this;
    _classCallCheck(this, InsufficientGasError);
    _this = _super.call(this, 'Not enough gas to pay for the operation');
    _defineProperty(_assertThisInitialized(_this), "name", 'InsufficientGasError');
    _this.asset = asset;
    return _this;
  }
  return _createClass(InsufficientGasError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var PendingSigningRequestError = /*#__PURE__*/function (_Error2) {
  _inherits(PendingSigningRequestError, _Error2);
  var _super2 = _createSuper(PendingSigningRequestError);
  function PendingSigningRequestError() {
    var _this2;
    _classCallCheck(this, PendingSigningRequestError);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _super2.call.apply(_super2, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this2), "name", 'PendingSigningRequestError');
    return _this2;
  }
  return _createClass(PendingSigningRequestError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var WalletConnectionErrorReason;
(function (WalletConnectionErrorReason) {
  WalletConnectionErrorReason["INCORRECT_CHAIN"] = "INCORRECT_CHAIN";
  WalletConnectionErrorReason["WRONG_ACCOUNT"] = "WRONG_ACCOUNT";
  WalletConnectionErrorReason["STALE_CONNECTION_REQUEST"] = "STALE_CONNECTION_REQUEST";
})(WalletConnectionErrorReason || (WalletConnectionErrorReason = {}));
var WalletConnectionError = /*#__PURE__*/function (_Error3) {
  _inherits(WalletConnectionError, _Error3);
  var _super3 = _createSuper(WalletConnectionError);
  function WalletConnectionError(reason) {
    var _this3;
    _classCallCheck(this, WalletConnectionError);
    _this3 = _super3.call(this, "Wallet connection failed due to ".concat(reason, " error"));
    _defineProperty(_assertThisInitialized(_this3), "name", 'WalletConnectionError');
    _this3.reason = reason;
    return _this3;
  }
  return _createClass(WalletConnectionError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var UserRejectedError = /*#__PURE__*/function (_Error4) {
  _inherits(UserRejectedError, _Error4);
  var _super4 = _createSuper(UserRejectedError);
  function UserRejectedError() {
    var _this4;
    _classCallCheck(this, UserRejectedError);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this4 = _super4.call.apply(_super4, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this4), "name", 'UserRejectedError');
    _defineProperty(_assertThisInitialized(_this4), "message", 'User rejected the request');
    return _this4;
  }
  return _createClass(UserRejectedError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var Wallet = /*#__PURE__*/_createClass(function Wallet(address) {
  _classCallCheck(this, Wallet);
  this.address = address;
});

export { InsufficientGasError, PendingSigningRequestError, UserRejectedError, Wallet, WalletConnectionError, WalletConnectionErrorReason };
